<template>
  <div class="previous-recorded-session-div" v-if="!showRecordedPreviousSession">
    <div class="back-icon-div">
      <span class="material-symbols-outlined hover-effect" @click="showRecordedPreviousSessionFn()">chevron_left</span>
      <span class="label-span">{{ props.heading }}</span>
    </div>
    <div class="custom-textarea-div">
      <Textarea v-model="selectedButtonLabel" :placeholder="`Add ${props.heading}...`" class="custom-textarea"
        @keydown.tab="showRecordedPreviousSessionFn()" disabled />
    </div>
  </div>
  <div v-else>
    <RecordedPreviousSessionDetails />
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import Textarea from 'primevue/textarea'
import { defineProps, onMounted, ref } from 'vue'
import RecordedPreviousSessionDetails from './RecordedPreviousSessionDetails.vue'

const selectedButtonLabel = ref('')
const showRecordedPreviousSession = ref(false)

const props = defineProps({
  selectedLabel: {
    type: String,
    required: true,
  },
  heading: {
    type: String,
    required: true,
  },
})

const showRecordedPreviousSessionFn = () => showRecordedPreviousSession.value = true

onMounted(() => {
  selectedButtonLabel.value = props.selectedLabel
})

</script>

<style scoped>
.previous-recorded-session-div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  gap: 12px;
}

.back-icon-div {
  display: flex;
  align-items: center;
  width: 100%;
}

.hover-effect {
  margin-right: 4%;
  margin-bottom: 4%;
  cursor: pointer;
}

.label-span {
  color: var(--Grey600);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 3.5%;
}

.custom-textarea-div .custom-textarea {
  height: 20vh;
  width: 15vw;
  background-color: var(--White);
}
</style>
